import React from "react";
import ReactDOM from "react-dom";
import Startup from "./components/Startup/Component";

/**
 * We recommend wrapping most or all of your components in the MsalProvider component. It's best to render the MsalProvider as close to the root as possible.
 */
ReactDOM.render(<Startup />, document.getElementById("root"));
